// Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.

export enum PrecisionAgWizardPageMode {
  Boundary = 'Field Boundary',
  Headlands = 'Headlands',
  Obstacles = 'Obstacles'
}

export enum PrecisionAgPolygonColors {
  Boundary = '#ff0000',
  Headlands = '#008000',
  Obstacles = '#ff0000'
}

export enum PrecisionAgPolygonZIndex {
  Boundary = 0,
  Headlands = 1,
  Obstacles = 2
}

// SVG paths for icons
export enum PrecisionAgPolygonIcons {
  Boundary = '',
  Headlands = '',
  Obstacles = 'M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1M9.12,7.71L7.71,9.12L10.59,12L7.71,14.88L9.12,16.29L12,13.41L14.88,16.29L16.29,14.88L13.41,12L16.29,9.12L14.88,7.71L12,10.59'
}
